import { WBRenderProps } from "vagaro-website-rendering/src/components/Definitions/WBRenderProps";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
import { ResizeableType, WBComponent } from "./WBComponent";
import LayoutNode, { getNodeComponentAttributeValue, setNodeStyleAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { assignDomRef, GetNodeDomAttributes } from "vagaro-website-rendering/src/components/Utilities/GetNodeDomAttributes";
import React from "react";
import CreateAttributeList from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";
import WebDesigner from "../WebDesigner";
import { defaultDropList } from "../Data/WBComponentDefaults";
import { ToggleNames } from "vagaro-website-rendering/src/components/Binding/BindAllToggles";
import { AttributeDefinition, AttributeInputType } from "../Data/WBData";
import { CreateBlankLayoutNode } from "../WBCanvas";
import {AlignCenterHorizontal, AlignLeft, AlignRight } from "../Icons/AlignmentIcons";


export default class WBAccordion extends WBComponent {

    constructor() {
        super();
        this.typename = wBComponentTypeNames.accordion;
        this.dropList = defaultDropList.filter(x=>x!=wBComponentTypeNames.accordion&&x!=wBComponentTypeNames.grid);
        this.displayName = "Accordion";

        this.primaryEditAttributes = [
          "accordionLabel",
          "accordionLayout",
          "accordionStartExpanded",
          "accordionAlign",

          "accordionPadding",
          "accordionRadius",
          "accordionBorderWidth",




        ]

        this.colorFields = ["accordionTextColor","accordLabelBg","accordionBorderColor","color","backgroundColor"];
        this.editList=[
        ...this.primaryEditAttributes,
        ...this.colorFields,
        ...CreateAttributeList(true,true,true,true,false,true,true).filter(x=>x!="height")

      ];



      this.resizeType = ResizeableType.HorizontalOnly;
      this.icon = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" height={"1em"} fill="currentColor"><path d="M384 432c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0zm64-16c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320zM207 345L103 241c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l87 87 87-87c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L241 345c-9.4 9.4-24.6 9.4-33.9 0z"/></svg>

    }



    onFirstTimeCreation(newParent: LayoutNode, thisLayout: LayoutNode, manager: WebDesigner): void {
      let text = CreateBlankLayoutNode(wBComponentTypeNames.text);

      setNodeStyleAttributeValue(thisLayout,0,"fontSize","1.25em");
      setNodeStyleAttributeValue(thisLayout,0,"fontWeight","600");
      setNodeStyleAttributeValue(text,0,"width","100%");
      setNodeStyleAttributeValue(text,0,"padding","12px");
      thisLayout.children = [text];
      manager.layoutNodeDictionary[text.id] = text;

    }

    getComponentSpecificAttributeDefinitions(): AttributeDefinition[] {

      const lbl =    new AttributeDefinition("accordionLabel","Label","",AttributeInputType.InputFiled);
      lbl.placeHolder = "Accordion Label...";

      const lblStyle = {borderRadius:"3px",padding:"4px 8px",border:"1px solid #c7c7c7",minWidth:"100px",marginRight:"5px"}
      return [
        lbl,
        new AttributeDefinition("accordionLayout","Accordion Style","",AttributeInputType.SelectField,
        [
          {label:"Auto",value:""},
          {label:<div className="flex-row gap-med justify-between" style={lblStyle}><span>Label </span><AccordionSolidCaret/></div>,value:"caret-right"},
          {label:<div className="flex-row gap-med justify-between" style={lblStyle}><span>Label </span><AccordionAngle/></div>,value:"angle-right"},
          {label:<div className="flex-row gap-med justify-between" style={lblStyle}><span>Label </span><PlusIcon/></div>,value:"minus-right"},
          {label:<div className="flex-row gap-small " style={lblStyle}><AccordionSolidCaret/><span>Label </span></div>,value:"caret-left"},
          {label:<div className="flex-row gap-small" style={lblStyle}><AccordionAngle/><span>Label </span></div>,value:"angle-left"},
          {label:<div className="flex-row gap-small" style={lblStyle}><PlusIcon/><span>Label </span></div>,value:"minus-left"},

        ]),
        new AttributeDefinition("accordionStartExpanded","Default View","",AttributeInputType.ButtonField,
        [
          {label:"Collapsed",value:""},
          {label:"Expanded",value:"expanded"},

        ]),
        new AttributeDefinition("accordionAlign","Align Content","",AttributeInputType.ButtonField,
[
  {label:"Auto",value:""},
  {label:<AlignLeft/>,value:"flex-start",toolTip:"Align Left"},
  {label:<AlignCenterHorizontal/>,value:"center",toolTip:"Align Center"},
  {label:<AlignRight/>,value:"flex-end",toolTip:"Align Right"},

]),

        new AttributeDefinition("accordionPadding","Label Padding","",AttributeInputType.FourwayMeasurmentField,
        [
          {label:"Auto",value:""},
          {label:"S",value:"0px"},
          {label:"M",value:"10px"},
          {label:"L",value:"20px"}

        ],{min:0,max:250,step:1,unit:"px"}),
        new AttributeDefinition("accordionBorderWidth","Label Border Width","",AttributeInputType.FourwayMeasurmentField,
        [
        {label:"Auto",value:""},
        {label:"S",value:"1px"},
        {label:"M",value:"3px"},
        {label:"L",value:"6px"}

        ],{min:0,max:20,step:1,unit:"px",default:0}),

        new AttributeDefinition("accordionBorderColor","Label Border Color","",AttributeInputType.ColorField),
        new AttributeDefinition("accordionRadius","Label Radius","",AttributeInputType.FourwayMeasurmentField,
        [
          {label:"Auto",value:""},
          {label:"S",value:"5px"},
          {label:"M",value:"10px"},
          {label:"L",value:"20px"}

        ],{min:0,max:500,step:1,unit:"px"}),
        new AttributeDefinition("accordionTextColor","Label Text","",AttributeInputType.ColorField),
        new AttributeDefinition("accordLabelBg","Label Background","",AttributeInputType.ColorField),
      ]
    }

    RenderLayout({component,children,screenSize,isEditor}:WBRenderProps): JSX.Element {

      const startExpanded = getNodeComponentAttributeValue(component,"accordionStartExpanded","")=="expanded";

      let on = (isEditor||startExpanded)?ToggleNames.toggledOn:"";

      const atts = GetNodeDomAttributes("v-accordion max-100 w-full "+on+" " +ToggleNames.toggleable,component,screenSize,isEditor);

      let lbl = getNodeComponentAttributeValue(component,"accordionLabel","Unlabeled");
      let clr = getNodeComponentAttributeValue(component,"accordLabelBg","white");
      let txtClr = getNodeComponentAttributeValue(component,"accordionTextColor","");
      let rdis = getNodeComponentAttributeValue(component,"accordionRadius","");
      let pding = getNodeComponentAttributeValue(component,"accordionPadding","");
      let borderWidth = getNodeComponentAttributeValue(component,"accordionBorderWidth","0");
      let borderColor = getNodeComponentAttributeValue(component,"accordionBorderColor","black");
      let align = getNodeComponentAttributeValue(component,"accordionAlign","center");
      let layout = getNodeComponentAttributeValue(component,"accordionLayout","");
      let icon = <AccordionSolidCaret/>;
      if(layout=="caret-right"){
        icon = <AccordionSolidCaret/>
      }
      else if(layout=="angle-right"){
        icon = <AccordionAngle/>
      }
      else if(layout=="minus-right"){
        icon = <AccordianMinus/>
      }
      else if(layout=="caret-left"){
        icon = <AccordionSolidCaret/>
      }
      else if(layout=="angle-left"){
        icon = <AccordionAngle/>
      }
      else if(layout=="minus-left"){
        icon = <AccordianMinus/>
      }



      return  <div {...atts} >
        <div onDoubleClick={tryEditLabel} className={`${layout.includes("left")?"left":""} ${ToggleNames.toggleTrigger} ${ToggleNames.findToggleInParent} accordion-label`} style={{backgroundColor:clr,padding:pding,color:txtClr,borderRadius:rdis,borderWidth:borderWidth,borderColor:borderColor,borderStyle:"solid"}}>
        <span>{lbl}</span>
        {icon}
        </div>
        <div className="accordion-content flex-column " style={{fontSize:"14px",fontWeight:"normal",alignItems:align,alignContent:align}}>
            {children}
        </div>
      </div>
    }





}

function AccordionSolidCaret(){
  return  <div className="accordion-caret center-all"><svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" height=".75em" viewBox="0 0 256 512"><path d="M246.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6l0 256c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l128-128z"/></svg></div>
}
function AccordionAngle(){
  return  <div className="accordion-caret center-all"><svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" height=".75em"  viewBox="0 0 320 512"><path d="M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"/></svg></div>
}

function AccordianMinus(){
  return <div className="accordion-caret center-all plus-minus " style={{fontSize:".85em",width:".85em"}} >
    <svg className="first" fill="currentColor" height="1em"  xmlns="http://www.w3.org/2000/svg" style={{position:"absolute",transform:"rotateZ(90deg)"}} viewBox="0 0 448 512"><path d="M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z"/></svg>
    <svg className="second" fill="currentColor" height="1em" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z"/></svg>
  </div>
}

function PlusIcon(){
  return <div className="accordion-caret center-all plus-minus " style={{fontSize:".75em"}} ><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M248 72c0-13.3-10.7-24-24-24s-24 10.7-24 24V232H40c-13.3 0-24 10.7-24 24s10.7 24 24 24H200V440c0 13.3 10.7 24 24 24s24-10.7 24-24V280H408c13.3 0 24-10.7 24-24s-10.7-24-24-24H248V72z"/></svg></div>
}

function tryEditLabel(){

  let dom = document.querySelector("[placeholder='Accordion Label...']");
  if(dom){
    (dom as HTMLInputElement).focus();
  }
}
